import Comp, { IEmailFormForwardRef } from "./EmailForm";

export default Comp;
export type { IEmailFormForwardRef };
